import { useEffect, useState } from "react";
import { useTheme } from "../context/ThemeContext";
import ProtectedImage from "../components/ProtectedImage";

// Deterministic rotation pattern for scattered/polaroid feel
const ROTATIONS = [-3, 2.5, -1.5, 3.2, -2.2, 1.8, -3.5, 2.1, -1, 3.5];

export default function TheCat() {
  const [photos, setPhotos] = useState([]);
  const { dark } = useTheme();

  useEffect(() => {
    fetch("/api/catphotos")
      .then((r) => r.json())
      .then(setPhotos)
      .catch(() => {});
  }, []);

  return (
    <div
      className="min-h-screen transition-colors duration-300"
      style={{ background: dark ? "#1a1520" : "#fff5f8" }}
    >
      {/* Hero */}
      <header className="text-center pt-20 pb-10 px-4">
        <h1
          className="text-5xl md:text-6xl font-bold mb-3"
          style={{ color: dark ? "#f0c8d8" : "#c06080" }}
        >
          My Tuki 🩷
        </h1>
        <p className="text-lg" style={{ color: dark ? "#9a8090" : "#b07080" }}>
          The CEO of this household. Every photo is a masterpiece, obviously.
        </p>
      </header>

      {/* Polaroid / scattered layout */}
      <main className="max-w-5xl mx-auto px-6 pb-24">
        {photos.length === 0 && (
          <p
            className="text-center py-24 text-lg"
            style={{ color: dark ? "#6a5060" : "#c090a0" }}
          >
            Tuki is being shy. Photos coming soon! 🐾
          </p>
        )}

        <div className="flex flex-wrap gap-8 justify-center">
          {photos.map((p, i) => (
            <PolaroidCard
              key={p.id}
              photo={p}
              dark={dark}
              rotation={ROTATIONS[i % ROTATIONS.length]}
            />
          ))}
        </div>
      </main>
    </div>
  );
}

function PolaroidCard({ photo, dark, rotation }) {
  return (
    <div
      className="transition-all duration-300 hover:!rotate-0 hover:scale-105 hover:z-10 relative cursor-default"
      style={{
        transform: `rotate(${rotation}deg)`,
        background: dark ? "#2a2030" : "#ffffff",
        padding: "10px 10px 36px 10px",
        borderRadius: 3,
        boxShadow: dark
          ? "0 10px 30px rgba(0,0,0,0.6), 0 2px 8px rgba(0,0,0,0.4)"
          : "0 10px 30px rgba(180,120,140,0.25), 0 2px 8px rgba(0,0,0,0.1)",
        width: 220,
      }}
    >
      <div style={{ overflow: "hidden", width: 200, height: 200 }}>
        <ProtectedImage
          src={`/api/catphotos/${photo.id}/image`}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>

      {photo.title && (
        <p
          className="text-center mt-2 text-sm"
          style={{
            fontFamily: "'Segoe UI', cursive, sans-serif",
            color: dark ? "#c0a0b0" : "#a07080",
          }}
        >
          {photo.title}
        </p>
      )}
    </div>
  );
}
